import {
  saveDocuments,
  updateCenterProfile,
  fetchSubsidies,
  fetchPhilosophies,
  fetchScheduleTypes,
  updateProviderInfo,
} from './profileEditor.service';

export default {
  namespaced: true,
  state: {
    documents: [],
    subsidies: {
      availableSubsidies: [],
      enabledSubsidies: [],
    },
    scheduleTypes: [],
    philosophies: [],
  },
  mutations: {
    setDocuments(state, documents) {
      state.documents = documents;
    },
    setSubsidies(state, subsidies) {
      state.subsidies = subsidies;
    },
    setScheduleTypes: (state, scheduleTypes) => {
      state.scheduleTypes = scheduleTypes;
    },
    setPhilosophies: (state, philosophies) => {
      state.philosophies = philosophies;
    },
  },
  actions: {
    async updateCenterProfile({ dispatch }, data) {
      try {
        await updateCenterProfile(data, data.centerId);
      } catch (error) {
        dispatch('notifications/addToastError', {
          text: 'This facility could not be updated, please ensure all information is correct and try again.',
          error,
        }, { root: true });
      }
    },

    initDocuments({ commit }, { documents }) {
      commit('setDocuments', documents || []);
    },

    async saveDocuments({ dispatch, commit }, data) {
      try {
        const response = await saveDocuments(data);
        if (response.data.documents) {
          commit('setDocuments', response.data.documents);
        }
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not save document', error }, { root: true });
      }
    },

    async fetchSubsidies({ dispatch, commit }, centerID) {
      try {
        const response = await fetchSubsidies(centerID);
        if (response.success) {
          commit('setSubsidies', { availableSubsidies: response.availableSubsidies, enabledSubsidies: response.enabledSubsidies });
        }
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not fetch subsidies', error }, { root: true });
      }
    },

    async fetchScheduleTypes({ commit, dispatch }) {
      try {
        const scheduleTypes = await fetchScheduleTypes();
        commit('setScheduleTypes', scheduleTypes);
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not fetch schedule types', error }, { root: true });
      }
    },

    async fetchPhilosophies({ commit, dispatch }) {
      try {
        const philosophies = await fetchPhilosophies();
        commit('setPhilosophies', philosophies);
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not fetch philosophies', error }, { root: true });
      }
    },

    async updateProviderInfo({ dispatch }, data) {
      try {
        await updateProviderInfo(data);
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not update provider info', error }, { root: true });
      }
    },
  },
};
